import makeUrl from '@/utils/makeUrl';
const orderApiPre = `/api/order`;
const orderApiList = [
	// 会员支付方式
	'payType',
	// 会员余额列表
	'accountList',
	// 提交订单
	'orderSubmit',
	// 订单列表
	'list',
	// 订单待支付
	'needPay',
	// 订单状态
	'status',
	// 订单确认
	'orderConfirm',
	// 订单确认优惠券列表
	'couponList',
	// 优惠券使用
	'discountCode',
	// 订单自提时间列表
	'takeTimeList',
	// 订单优惠码确认
	'discountCode',
	// 订单评价
	'comment',
	// 订单评价页面信息
	'commentInfo',
	// 订单详情
	'detail',
	// 评论上传图片
	'uploadImg',
	// 评价详情
	'commentDetail',
	// 获取门店最近地址
	'getRecentAddress',
];
const orderApi = {};

orderApiList.forEach(key => {
	orderApi[`${key}Url`] = makeUrl(orderApiPre, key);
});
orderApi.paySubmitUrl = `api/orderPay/paySubmit`
orderApi.orderOtherUrl = 'api/order/orderOther'
export default orderApi;